import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { mapGetters } from 'vuex';
import { rqtGetAgent } from '@/services/ams/agent';
import { rqtGetStore } from '@/services/common/store';
import { rqtPostAttachmentList, getFileUrl } from '@/services/common/attachment';
export default {
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {
      agent: {},
      store: {},
      attachment: {}
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  created() {
    rqtGetAgent(this.user.agentId).then(res => {
      const resData = res.data.data;
      this.agent = resData.agent;
      this.agent.storeId && rqtGetStore(this.agent.storeId).then(res => {
        const resData = res.data.data;
        this.store = resData.store;
      }).catch(() => {});
    }).catch(() => {});
    this.getAttachmentInfo();
  },
  methods: {
    getAttachmentInfo() {
      let params = {
        businessId: this.user.agentId,
        attachmentType: 61,
        attachmentSubType: 6101
      };
      rqtPostAttachmentList(params).then(res => {
        const resData = res.data.data;
        this.attachment = resData && resData[0];
      }).catch(() => {});
    },
    getFileUrl
  }
};